<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import FGroup from "@/components/Form/FGroup.vue";
import FInput from "@/components/Form/Input/FInput.vue";
import FSelect from "@/components/Form/Select/FSelect.vue";
import CButton from "@/components/Common/CButton.vue";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";

import { unref } from "vue";
interface Props {
  show: boolean;
  title: "add_exchange" | "edit_exchange";
  form: any;
  loading: boolean;
  customDialogClass?: string;
  type: "edit" | "add";
}
const props = defineProps<Props>();

interface Emits {
  (e: "close"): void;
  (e: "submit"): void;
}
defineEmits<Emits>();

const form = unref(props.form);

const list = [
  {
    title: "binance",
    type: "binance",
    icon: "/binance-logo.svg",
  },
  {
    title: "kucoin",
    type: "kucoin",
    icon: "/kucoin-logo.svg",
  },
];
</script>

<template>
  <CDialog
    :custom-class="customDialogClass"
    :title="$t(title)"
    v-bind="{ show }"
    @close="$emit('close')"
  >
    <form class="p-5" @submit.prevent="$emit('submit')">
      <FGroup :label="$t('connection_name')">
        <FInput
          v-model="form.values.title"
          :error="form.$v.value.title.$error"
          :placeholder="$t('enter_name')"
        />
      </FGroup>
      <FGroup
        v-if="title !== 'edit_exchange'"
        :label="$t('exchange')"
        class="my-4"
      >
        <FSelect
          v-model="form.values.type"
          :error="form.$v.value.type.$error"
          :options="list"
          :placeholder="$t('choose_exchange')"
          label-key="title"
          value-key="type"
        />
      </FGroup>
      <template v-if="title !== 'edit_exchange'">
        <FGroup :label="$t('key')" class="my-4">
          <FInput
            :model-value="form.values.api_key"
            :error="form.$v.value.api_key.$error"
            :placeholder="$t('enter_key')"
            type="password"
            @update:model-value="form.values.api_key = $event"
          />
        </FGroup>
        <FGroup :label="$t('secret_key')" class="mt-4 mb-5">
          <FInput
            :placeholder="$t('enter_secret_key')"
            :model-value="form.values.secret_key"
            :error="form.$v.value.secret_key.$error"
            type="password"
            @update:model-value="form.values.secret_key = $event"
          />
        </FGroup>
      </template>
      <CollapseTransition>
        <FGroup :label="$t('password')" v-if="form.values.type === 'kucoin'">
          <FInput
            v-model="form.values.password"
            :error="form.$v.value.password.$error"
            :placeholder="$t('enter_password')"
          />
        </FGroup>
      </CollapseTransition>
      <CButton
        class="!py-2.5 w-full mt-2"
        :text="type === 'add' ? $t('add') : $t('change')"
        type="submit"
        :loading="loading"
      />
    </form>
    <template #afterBody>
      <slot name="footer" />
    </template>
  </CDialog>
</template>
